import * as React from 'react'
import Timer from './Timer'
import './TopHeader.scss'
import AdvertiseWithData from './AdvertiseWithData'
import EventType from '../../../models/eventType'
import { setEmarsysWebExtend } from '../../../utilities'

export type Props = {
    email?: string
    loading: boolean
    siteType?: 'event' | 'non-event'
    eventType?: EventType | null
    to: number
}

class TopHeader extends React.Component<Props> {
    componentDidUpdate(prevProps: Props) {
        if (prevProps.loading && !this.props.loading) {
            const env = process.env.REACT_APP_EMARSYS_ENVIRONMENT as string
            if (env.toLowerCase() !== 'live') {
                (window as any).ScarabQueue.push(['testMode'])
            }
            setEmarsysWebExtend(this.props.email)
        }
    }

    render() {
        const { to, siteType, eventType } = this.props

        return (
        <>
            {siteType === 'event' &&
                <div className={`top-header top-header--${eventType}`}>
                    <Timer to={to}/>
                </div>
            }
            {siteType === 'non-event' &&
                <div className={`top-header top-header--${eventType}`}>
                    <AdvertiseWithData/>
                </div>
            }
        </>
        )
    }
}

export {
    TopHeader
}
